export default __webpack_public_path__ + "static/media/MONUSCO_joint_protection_team.560df7c8.jpg";